
export const PermissionTypes = {
    None: 0,
    View: 1,
    Edit: 1 << 1,
    Delete: 1 << 2,
    Manage: 1 | (1 << 1) | (1 << 2),
    ViewPermission: 1 << 3,
    ManagePermissions: (1 << 3) | (1 << 4),
    TransferAccountOwnership: 1 << 29,
    DeleteAccount: 1 << 30,
    All: 0x7FFFFFFF,

    PartialAdmin: 0x7FFFFFFF & ~(1 << 29) & ~(1 << 30),
    Admin: 0x7FFFFFFF,
};